import { ADDON_REF_ID_MAPPING, PLAN_REF_ID_MAPPING } from "@/data/plans";
import { TAddOnRefId, TProductRefId } from "@/types/plan";
import { TAddOn } from "../types.checkout";

/**
 * Type guard to check if an ID is a product ref ID
 */
export function isProductRefId(id: string): id is TProductRefId {
  return Object.values(PLAN_REF_ID_MAPPING).includes(id as TProductRefId);
}

/**
 * Type guard to check if an ID is an addon ref ID
 */
export function isAddOnRefId(id: string): id is TAddOnRefId {
  return Object.values(ADDON_REF_ID_MAPPING).includes(id as TAddOnRefId);
}

/**
 * Get Add List based on cart items
 */
export function getAddOnByRules(
  items: TProductRefId[],
  addOnRulesMap: Partial<Record<TProductRefId, TAddOnRefId[]>>,
): TAddOnRefId[] {
  let allowedAddOns: TAddOnRefId[] = [];

  items.forEach((item) => {
    // Only check rules for product ref IDs (plans), not addon ref IDs
    if (isProductRefId(item as string)) {
      const addOnsForThisProduct = addOnRulesMap[item as TProductRefId];
      if (addOnsForThisProduct) {
        allowedAddOns.push(...addOnsForThisProduct);
      }
    }
  });

  // Remove duplicates
  return [...new Set(allowedAddOns)];
}

/**
 * Get addon cards by addon ref IDs for display
 */
export function getAddOnList(
  allowedAddOnIds: TAddOnRefId[],
  addOnCards: TAddOn[],
): TAddOn[] {
  return addOnCards.filter((addOnCard) =>
    allowedAddOnIds.includes(addOnCard.productRefId),
  );
}
